module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "y-select-item",
    class: {
      active: _vm.value == _vm._value, disabled: _vm.disabled
    },
    on: {
      "click": _vm.clicks
    }
  }, [_vm._v(_vm._s(_vm.label ? _vm.label : _vm.value))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-0e2d63b0!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/select/option.vue
// module id = 449
// module chunks = 27